import MUIContainer from '@/components/MUI-Components/MUI-Container';
import {PORTFOLIO_META_DATA} from '@/util/metaData/company';
import Box from '@mui/material/Box';
import dynamic from 'next/dynamic';
import PageHead from '@/components/PageHead';

import LatestPortfolioBanner from '@/components/Ui-components/LatestPortfolioBanner';
const LatestPortfolio = dynamic(() => import('@/components/Ui-components/LatestPortfolio'));
const BannerBottom = dynamic(() => import('@/components/Ui-components/banner-bottom'), {
    ssr: false
});
const HomeLatestCTA = dynamic(() => import('@/components/Ui-components/home/HomeLatestCTA'), {
    ssr: false
});
const Adoption = dynamic(() => import('@/components/Ui-components/Adoption'), {
    ssr: false
});
import Container from '@mui/material/Container';
import {colors} from '@/styles/tokens';

// Migrated from globals.scss `.adoption-section` (sole consumer — this page only).
// (`@extend .blockchain-benifits-section !optional` resolves to nothing — that
// selector has no definition elsewhere, so it contributes no styling.)
const adoptionSectionSx = {
    backgroundColor: colors.primary.light,
    textAlign: 'center !important'
} as const;

const Portfolio = (props: any) => {
    const {openForm, bannerBottomPortfolio, latestPortfolioData, adptionData} = props;
    return (
        <Box>
            <MUIContainer maxWidth="lg" className="main-wrapper">
                <PageHead meta={PORTFOLIO_META_DATA} url="/portfolio" />
            </MUIContainer>

            <Box>
                <LatestPortfolioBanner
                    heading="Real Projects, Measurable Results."
                    subheading="Explore our diverse portfolio of Web3, mobile app, and web development projects that showcase our commitment to innovation, quality, and client satisfaction. From cutting-edge blockchain solutions to captivating mobile experiences and stunning web designs, we take pride in delivering excellence with every project."
                />
            </Box>
            <Box className="home-banner-bottom helper_section_parent">
                <BannerBottom bannerData={bannerBottomPortfolio} ourPartner={true} />
            </Box>
            <Box className="top-space mobile-top-padding bottom-space mobile-bottom-padding">
                <LatestPortfolio heading="Success Stories" contentData={latestPortfolioData} openForm={openForm} />
            </Box>
            <Box className="adoption-section bottom-spacing" sx={adoptionSectionSx}>
                <Container maxWidth="lg">
                    <Adoption
                        heading="Our Diverse Web and Mobile Expertise"
                        subheading="Explore a selection of our web and mobile projects, providing a glimpse into our diverse expertise. These projects reflect our commitment to delivering exceptional digital solutions."
                        contentData={adptionData}
                    />
                </Container>
            </Box>
            <Box className=" bottom-spacing top-space mobile-top-padding mobile-bottom-padding">
                <HomeLatestCTA
                    heading="Turn Industry Complexity Into Scalable Software"
                    subheading="Apply full-stack expertise across FinTech, eCommerce, Healthcare, and Aviation to build scalable, secure, and future-ready systems."
                    buttonText="Talk to Our Experts"
                    openForm={openForm}
                />
            </Box>
        </Box>
    );
};
export async function getStaticProps() {
    const {bannerBottomPortfolio, latestPortfolioData} = await import('@/util/contents/latest-portfolio-data');
    const {adptionData} = await import('@/util/contents/portfolio-data');

    return {
        props: {
            bannerBottomPortfolio,
            latestPortfolioData,
            adptionData
        }
    };
}

export default Portfolio;
Portfolio.Layout = 'Main';
